<template>
  <div class="data-field-v">
    <template v-if="fieldViewContainer">
      <component :is="fieldViewContainer"
                 v-bind="$attrs"></component>
    </template>
    <template v-else>
      <div class="not-supported-type">
        <span>不支持的字段类型</span>
        <span v-if="type">[{{type}}]</span>
      </div>
    </template>
  </div>
</template>

<script>
import InputField from './field/InputField'
import TextareaField from './field/TextareaField'
import RichTextField from './field/RichTextField'
import ImageField from './field/ImageField'
import FileField from './field/FileField'
export default {
  name: 'DataFieldV',
  props: {
    type: String
  },
  computed: {
    fieldViewContainer () {
      switch (this.type) {
        case 'input':
          return InputField
        case 'textarea':
          return TextareaField
        case 'richText':
          return RichTextField
        case 'image':
          return ImageField
        case 'file':
          return FileField
        default:
          break
      }
    }
  }
}
</script>
